export const getIncidentType = incident => {
  if (incident.someoneInjured && incident.injureOrFatality === 'fatality') {
    return 'fatalCase'
  } else if (incident.someoneInjured && incident.injureOrFatality === 'injury') {
    return 'LTI'
  } else {
    return 'nonLTI'
  }
}
